import axios from "axios";

import { ICreateOrderResponse } from "../../../types/api";

export interface ICreateOrderParameters {
    customerId: string;
    billingCustomerAddressId: string;
    note?: string;
    shippingCustomerAddressId: string;
    test?: boolean;
    cartId: string;
    token: string;
    platform: number;
}

export interface IResendPaymentParameters {
    orderId: string;
    token: string;
}

export class Orders {
    static async create(
        parameters: ICreateOrderParameters,
    ): Promise<ICreateOrderResponse> {
        const { token, ...body } = parameters;
        const { data } = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/api/admins/v2/orders`,
            body,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    "Admin-Request": "true",
                },
            },
        );
        return data;
    }

    static async resendPaymentLink(
        parameters: IResendPaymentParameters,
    ): Promise<ICreateOrderResponse> {
        const { token, orderId } = parameters;
        const response = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/api/admins/v2/orders/${orderId}/resend-payment`,
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    "Admin-Request": "true",
                },
            },
        );
        return response.data;
    }
}
